import dayjs from 'dayjs'

type UtcFormatInput = string | Date | null | undefined

export const getUtcMonth = (date: UtcFormatInput, fallback: string = null) => {
  if (!date) return fallback
  return dayjs(date).utc().format('MM/YYYY')
}

export const getUtcDate = (date: UtcFormatInput, fallback: string = null) => {
  if (!date) return fallback
  return dayjs(date).utc().format('MM/DD/YYYY')
}

/**
 * Convert a UTC month-boundary ISO string (e.g. an employment-gap start/end,
 * which are UTC start-/end-of-month values) into a local Date whose local
 * year/month match the UTC year/month. Building a Date directly from the ISO
 * string (`new Date(iso)`) makes month pickers read local year/month, so
 * viewers west of UTC see the previous month (a 09/2022 gap prefills as
 * 08/2022). Noon avoids DST edges. Mirrors how MonthInput handles backend ISO
 * strings. Returns undefined for missing/invalid input.
 */
export const utcMonthToLocalDate = (iso?: string | null): Date | undefined => {
  if (!iso) return undefined
  const parsed = new Date(iso)
  if (Number.isNaN(parsed.getTime())) return undefined
  return new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), 1, 12, 0, 0, 0)
}
